var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { memo } from 'react';
import * as React from "react";
var SvgChatBubbleFilled24 = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22.03 12c0 5.54-4.491 10.03-10.03 10.03a9.983 9.983 0 0 1-5.084-1.381l-2.536.927c-1.199.438-2.362-.726-1.924-1.924l.922-2.522A9.984 9.984 0 0 1 1.968 12C1.969 6.46 6.46 1.97 12 1.97c5.54 0 10.03 4.49 10.03 10.03ZM8.532 12a1.125 1.125 0 1 1-2.249 0 1.125 1.125 0 0 1 2.25 0ZM12 13.125a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25Zm4.59 0a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25Z",
    clipRule: "evenodd"
  })));
});
SvgChatBubbleFilled24.displayName = "SvgChatBubbleFilled24";
export default SvgChatBubbleFilled24;